export default {
    ERRORS: {
        default: "Unfortunately, there was an error. Please try again."
    }
}